import { useAsyncResult } from '@client/new/helpers/gql';
import {
  useGetReportedContentQuery,
  useKeepContentMutation,
  KeepContentMutation,
  useDeletePostMutation,
  useDeleteReplyMutation,
  DeletePostMutation,
  DeleteReplyMutation,
  useBlockUserMutation,
  BlockUserMutation,
} from '../../../../generated/graphql';
import { useState, useEffect } from 'react';
import _ from 'lodash';
import { ReportedItem } from '../components/ContentOverview';

export const useReportedContent = (communityId: number) => {
  const { data, loading, refetch } = useGetReportedContentQuery({
    variables: { communityId },
    fetchPolicy: 'network-only',
  });

  const [reportedContent, setReportedContent] = useState<ReportedItem[]>([]);

  const hasReportedContent = (data?.reportedContent ?? []).length > 0;

  const [deletePostMutation, deletePostStateRaw] = useDeletePostMutation();
  const deletePostState =
    useAsyncResult<DeletePostMutation>(deletePostStateRaw);

  const [deleteReplyMutation, deleteReplyStateRaw] = useDeleteReplyMutation();
  const deleteReplyState =
    useAsyncResult<DeleteReplyMutation>(deleteReplyStateRaw);
  const isDeleteProgress =
    deleteReplyState.type === 'fetching' || deletePostState.type === 'fetching';

  const [keepContentMutation, keepContentStateRaw] = useKeepContentMutation();
  const keepContentState =
    useAsyncResult<KeepContentMutation>(keepContentStateRaw);
  const isKeepProgress = keepContentState.type === 'fetching';

  const [blockUserMutation, blockUserStateRaw] = useBlockUserMutation();
  const blockUserState = useAsyncResult<BlockUserMutation>(blockUserStateRaw);

  useEffect(() => {
    data?.reportedContent &&
      setReportedContent(data.reportedContent as ReportedItem[]);
  }, [data]);

  return {
    reportedContent,
    refetch,
    loading,
    keepContentState,
    deletePostState,
    deleteReplyState,
    blockUserState,
    isDeleteProgress,
    isKeepProgress,
    hasReportedContent,
    deletePostMutation,
    deleteReplyMutation,
    keepContentMutation,
    blockUserMutation,
    initialData: (data?.reportedContent as ReportedItem[]) || [],
    setReportedContent,
  };
};
